import { Button, Card, Form, Modal, Spinner } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";
import countries from "../../../components/utils/countries";

const AddCompanyModal = ({
  show,
  onClose,
  companyName,
  setCompanyName,
  mobileNumber,
  setMobileNumber,
  description,
  setDescription,
  country,
  setCountry,
  location,
  setLocation,
  handleSubmitRequest,
  loading,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Company Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Card className="p-3">
          <Form>
            {/* Company Name */}
            <Form.Group controlId="companyName">
              <Form.Label>
                Company Name <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter company name"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </Form.Group>

            {/* Mobile */}
            <Form.Group controlId="mobileNumber" className="mt-2">
              <Form.Label>
                Mobile Number <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="tel"
                placeholder="Enter mobile number"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
              />
            </Form.Group>

            {/* Country Select */}
            <Form.Group controlId="country" className="mt-2">
              <Form.Label>
                Country <span style={{ color: "red" }}>*</span>
              </Form.Label>

              <CreatableSelect
                options={countries}
                value={countries.find((c) => c.value === country) || null}
                onChange={(selected) => setCountry(selected?.value)}
                placeholder="Select or type country"
                isClearable
              />
            </Form.Group>
            {/* Location */}
            <Form.Group controlId="location" className="mt-2">
              <Form.Label>
                Location <span style={{ color: "red" }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter location"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              />
            </Form.Group>

            {/* Description */}
            <Form.Group controlId="description" className="mt-2">
              <Form.Label>Company Description</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter short description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Form.Group>

            {/* Submit */}
            <Button
              className="mt-3"
              variant="success"
              onClick={handleSubmitRequest}
              disabled={!companyName || !mobileNumber || !country || !location}
            >
              {loading ? (
                <>
                  <Spinner as="span" animation="border" size="sm" />{" "}
                  Submitting...
                </>
              ) : (
                "Submit"
              )}
            </Button>
          </Form>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

export default AddCompanyModal;
